
























































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class DlgFileEdit extends Vue {
  public $refs!: {
    form: any,
    file: any,
  };

  @Prop({type: Object, default: null}) private file!: any;

  @Action('files/update') private updateFile!: any;
  @Action('files/read') private filesRead!: any;
  @Action('files/uploadFile') private uploadFile!: any;
  @Getter('rules/all') private rules!: any;
  @Getter('files/categories') private categories!: any;

  private loading: boolean = false;
  private fileName: any = '';
  private dialog: boolean = false;
  private localFile: any = {};
  private selectedFile: any;
  private valid: boolean = true;

  private save() {
    if (this.$refs.form.validate()) {
      // Upload file and save path
    }
  }

  private selectFile() {
    if (this.loading) {
      return;
    }
    this.$refs.file.click();
  }

  private onFilePicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.fileName = files[0].name;
      if (!this.file.title) {
        this.file.name = files[0].name;
      }

      this.selectedFile = files[0];
    }
  }

  private async upload() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      if (this.selectedFile) {
        this.localFile.url = await this.uploadFile(this.selectedFile);
      }
      await this.updateFile(this.localFile);
      await this.filesRead();
      this.selectedFile = null;
      this.loading = false;
      this.dialog = false;
    }
  }

  @Watch('dialog')
  private dialogOpened() {
    this.localFile = JSON.parse(JSON.stringify(this.file));
    this.fileName = '-- unverändert --';
  }
}
